import React from 'react'
import { Formik } from 'formik'
import * as yup from 'yup'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { SelectField } from '../../styles/forms'
import { Button } from '../../styles/generics'

const initialValues = { specialityId: '' }
const validations = yup.object().shape({
  specialityId: yup.string().required('Campo requerido')
})

const FormSpeciality = props => (
  <Formik
    onSubmit={props.handleSubmit}
    initialValues={initialValues}
    validationSchema={validations}
    render={renderProps => (
      <Form onSubmit={renderProps.handleSubmit}>
        <SelectField
          name="specialityId"
          id="specialityId"
          options={props.specialities}
          placeholder="Elegí una especialidad"
          warning={renderProps.errors.specialityId && renderProps.touched.specialityId}
        />

        {renderProps.values.specialityId === '97' && (        
          <Message>Te recordamos que la guardia Otorrinolaringológica funciona de 9 a 21hs</Message>
        )}

        <Button type="submit">Continuar</Button>
      </Form>
    )}
  />
)

FormSpeciality.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  specialities: PropTypes.array.isRequired
}

export default FormSpeciality

/*
 * Styles
 */
const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 15px 0;
  div:first-child {
    width: 520px;
  }
  button {
    width: 320px;
    margin-top: 40px;
  }
  @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
    width: 100%;
    div:first-child {
      width: 100%;
    }
    button {
      width: 100%;
      margin-top: 20px;
    }
  }
`
const Message = styled.div`
  margin-top: 15px;
  text-align: center;
  color: ${props => props.theme.colors.greyFour};
`
